import { ID } from "common/entities/IEntity";
import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "common/form/InputType";
import { Input } from "decorator-form";
import { Entity, Field } from "typegraph";
import entityMeta from "../entityMeta";



@Entity(entityMeta.CONTRIBUTOR)
class Contributor {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public avatarUrl: string;

	@Field()
	public designations: string;

	@Field()
	public description: string;

	@Field()
	public imageURL: string;


}

const contributorSelect = EntitySelect.registered<Contributor, Contributor, "one">({
	entity: Contributor,
	type: 'one',
	getValue: (c) => c,
	equals: (c1, c2) => c1.id === c2.id,
	getSearchParams: (query) => ({query, sort: "name"})
}, 'object');

@Entity(entityMeta.ARTICLE_CONTRIBUTOR)
export class ArticleContributor {

	@Field()
	public id: ID;

	@Field({entity: Contributor})
	@Input({
		type: contributorSelect,
		title: "Contributor",
		required: true
	})
	public contributor: Contributor;

	@Field()
	@Input({type: InputType.NUMBER_POSITIVE, title: "Sort Index"})
	public sortIndex: number;

	@Field()
	@Input({
		type: InputType.TEXT_HTML,
		title: "Contribution Description"
	})
	public description: string;

	@Field()
	@Input({type: InputType.CHECKBOX, title: "Primary Contributor"})
	public primary: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/articleContributor/entities.ts